/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ShellBookmarksRouteImport } from './routes/_shell/bookmarks'
import { Route as ShellEventsRouteImport } from './routes/_shell/events'
import { Route as ShellNotificationsRouteImport } from './routes/_shell/notifications'
import { Route as ShellReferenceRouteImport } from './routes/_shell/reference'
import { Route as ShellSettingsRouteImport } from './routes/_shell/settings'
import { Route as AuthAcceptInvitationRouteImport } from './routes/auth/accept-invitation'
import { Route as AuthConfirmEmailRouteImport } from './routes/auth/confirm-email'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as ShellDestinationsIndexRouteImport } from './routes/_shell/destinations.index'
import { Route as ShellDestinationsDestinationIdRouteImport } from './routes/_shell/destinations.$destinationId'
import { Route as ShellDevFlowKitRouteImport } from './routes/_shell/dev.flow-kit'
import { Route as ShellFlowsIndexRouteImport } from './routes/_shell/flows.index'
import { Route as ShellFlowsFlowIdRouteImport } from './routes/_shell/flows.$flowId'
import { Route as ShellIssuesIndexRouteImport } from './routes/_shell/issues.index'
import { Route as ShellIssuesIssueIdRouteImport } from './routes/_shell/issues.$issueId'
import { Route as ShellLibraryIndexRouteImport } from './routes/_shell/library.index'
import { Route as ShellLibraryItemIdRouteImport } from './routes/_shell/library.$itemId'
import { Route as ShellSettingsIndexRouteImport } from './routes/_shell/settings.index'
import { Route as ShellSettingsAccountRouteImport } from './routes/_shell/settings.account'
import { Route as ShellSettingsAiUsageRouteImport } from './routes/_shell/settings.ai-usage'
import { Route as ShellSettingsCredentialsRouteImport } from './routes/_shell/settings.credentials'
import { Route as ShellSettingsDomainsRouteImport } from './routes/_shell/settings.domains'
import { Route as ShellSettingsKeysRouteImport } from './routes/_shell/settings.keys'
import { Route as ShellSettingsMembersRouteImport } from './routes/_shell/settings.members'
import { Route as ShellSettingsNotificationsRouteImport } from './routes/_shell/settings.notifications'
import { Route as ShellSettingsOrganizationRouteImport } from './routes/_shell/settings.organization'
import { Route as ShellSettingsStorageRouteImport } from './routes/_shell/settings.storage'
import { Route as ShellSourcesIndexRouteImport } from './routes/_shell/sources.index'
import { Route as ShellSourcesSourceIdRouteImport } from './routes/_shell/sources.$sourceId'
import { Route as ShellTransformsIndexRouteImport } from './routes/_shell/transforms.index'
import { Route as ShellTransformsTransformIdRouteImport } from './routes/_shell/transforms.$transformId'
import { Route as ShellEventsRunsRunIdRouteImport } from './routes/_shell/events_.runs.$runId'
import { Route as ShellSourcesSourceIdClientsIndexRouteImport } from './routes/_shell/sources.$sourceId.clients.index'
import { Route as ShellSourcesSourceIdClientsCustomerIdRouteImport } from './routes/_shell/sources.$sourceId.clients.$customerId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellBookmarksRoute = ShellBookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => ShellRoute,
} as any)
const ShellEventsRoute = ShellEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNotificationsRoute = ShellNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => ShellRoute,
} as any)
const ShellReferenceRoute = ShellReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSettingsRoute = ShellSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ShellRoute,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/auth/accept-invitation',
  path: '/auth/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfirmEmailRoute = AuthConfirmEmailRouteImport.update({
  id: '/auth/confirm-email',
  path: '/auth/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellDestinationsIndexRoute = ShellDestinationsIndexRouteImport.update({
  id: '/destinations/',
  path: '/destinations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDestinationsDestinationIdRoute =
  ShellDestinationsDestinationIdRouteImport.update({
    id: '/destinations/$destinationId',
    path: '/destinations/$destinationId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellDevFlowKitRoute = ShellDevFlowKitRouteImport.update({
  id: '/dev/flow-kit',
  path: '/dev/flow-kit',
  getParentRoute: () => ShellRoute,
} as any).lazy(() =>
  import('./routes/_shell/dev.flow-kit.lazy').then((d) => d.Route),
)
const ShellFlowsIndexRoute = ShellFlowsIndexRouteImport.update({
  id: '/flows/',
  path: '/flows/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFlowsFlowIdRoute = ShellFlowsFlowIdRouteImport.update({
  id: '/flows/$flowId',
  path: '/flows/$flowId',
  getParentRoute: () => ShellRoute,
} as any).lazy(() =>
  import('./routes/_shell/flows.$flowId.lazy').then((d) => d.Route),
)
const ShellIssuesIndexRoute = ShellIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIssuesIssueIdRoute = ShellIssuesIssueIdRouteImport.update({
  id: '/issues/$issueId',
  path: '/issues/$issueId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLibraryIndexRoute = ShellLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLibraryItemIdRoute = ShellLibraryItemIdRouteImport.update({
  id: '/library/$itemId',
  path: '/library/$itemId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSettingsIndexRoute = ShellSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsAccountRoute = ShellSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsAiUsageRoute = ShellSettingsAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsCredentialsRoute =
  ShellSettingsCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => ShellSettingsRoute,
  } as any)
const ShellSettingsDomainsRoute = ShellSettingsDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsKeysRoute = ShellSettingsKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsMembersRoute = ShellSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSettingsNotificationsRoute =
  ShellSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ShellSettingsRoute,
  } as any)
const ShellSettingsOrganizationRoute =
  ShellSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => ShellSettingsRoute,
  } as any)
const ShellSettingsStorageRoute = ShellSettingsStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => ShellSettingsRoute,
} as any)
const ShellSourcesIndexRoute = ShellSourcesIndexRouteImport.update({
  id: '/sources/',
  path: '/sources/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSourcesSourceIdRoute = ShellSourcesSourceIdRouteImport.update({
  id: '/sources/$sourceId',
  path: '/sources/$sourceId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTransformsIndexRoute = ShellTransformsIndexRouteImport.update({
  id: '/transforms/',
  path: '/transforms/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTransformsTransformIdRoute =
  ShellTransformsTransformIdRouteImport.update({
    id: '/transforms/$transformId',
    path: '/transforms/$transformId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellEventsRunsRunIdRoute = ShellEventsRunsRunIdRouteImport.update({
  id: '/events_/runs/$runId',
  path: '/events/runs/$runId',
  getParentRoute: () => ShellRoute,
} as any).lazy(() =>
  import('./routes/_shell/events_.runs.$runId.lazy').then((d) => d.Route),
)
const ShellSourcesSourceIdClientsIndexRoute =
  ShellSourcesSourceIdClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => ShellSourcesSourceIdRoute,
  } as any)
const ShellSourcesSourceIdClientsCustomerIdRoute =
  ShellSourcesSourceIdClientsCustomerIdRouteImport.update({
    id: '/clients/$customerId',
    path: '/clients/$customerId',
    getParentRoute: () => ShellSourcesSourceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/bookmarks': typeof ShellBookmarksRoute
  '/events': typeof ShellEventsRoute
  '/notifications': typeof ShellNotificationsRoute
  '/reference': typeof ShellReferenceRoute
  '/settings': typeof ShellSettingsRouteWithChildren
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/destinations/$destinationId': typeof ShellDestinationsDestinationIdRoute
  '/dev/flow-kit': typeof ShellDevFlowKitRoute
  '/flows/$flowId': typeof ShellFlowsFlowIdRoute
  '/issues/$issueId': typeof ShellIssuesIssueIdRoute
  '/library/$itemId': typeof ShellLibraryItemIdRoute
  '/settings/account': typeof ShellSettingsAccountRoute
  '/settings/ai-usage': typeof ShellSettingsAiUsageRoute
  '/settings/credentials': typeof ShellSettingsCredentialsRoute
  '/settings/domains': typeof ShellSettingsDomainsRoute
  '/settings/keys': typeof ShellSettingsKeysRoute
  '/settings/members': typeof ShellSettingsMembersRoute
  '/settings/notifications': typeof ShellSettingsNotificationsRoute
  '/settings/organization': typeof ShellSettingsOrganizationRoute
  '/settings/storage': typeof ShellSettingsStorageRoute
  '/sources/$sourceId': typeof ShellSourcesSourceIdRouteWithChildren
  '/transforms/$transformId': typeof ShellTransformsTransformIdRoute
  '/destinations/': typeof ShellDestinationsIndexRoute
  '/flows/': typeof ShellFlowsIndexRoute
  '/issues/': typeof ShellIssuesIndexRoute
  '/library/': typeof ShellLibraryIndexRoute
  '/settings/': typeof ShellSettingsIndexRoute
  '/sources/': typeof ShellSourcesIndexRoute
  '/transforms/': typeof ShellTransformsIndexRoute
  '/events/runs/$runId': typeof ShellEventsRunsRunIdRoute
  '/sources/$sourceId/clients/$customerId': typeof ShellSourcesSourceIdClientsCustomerIdRoute
  '/sources/$sourceId/clients/': typeof ShellSourcesSourceIdClientsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/bookmarks': typeof ShellBookmarksRoute
  '/events': typeof ShellEventsRoute
  '/notifications': typeof ShellNotificationsRoute
  '/reference': typeof ShellReferenceRoute
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/destinations/$destinationId': typeof ShellDestinationsDestinationIdRoute
  '/dev/flow-kit': typeof ShellDevFlowKitRoute
  '/flows/$flowId': typeof ShellFlowsFlowIdRoute
  '/issues/$issueId': typeof ShellIssuesIssueIdRoute
  '/library/$itemId': typeof ShellLibraryItemIdRoute
  '/settings/account': typeof ShellSettingsAccountRoute
  '/settings/ai-usage': typeof ShellSettingsAiUsageRoute
  '/settings/credentials': typeof ShellSettingsCredentialsRoute
  '/settings/domains': typeof ShellSettingsDomainsRoute
  '/settings/keys': typeof ShellSettingsKeysRoute
  '/settings/members': typeof ShellSettingsMembersRoute
  '/settings/notifications': typeof ShellSettingsNotificationsRoute
  '/settings/organization': typeof ShellSettingsOrganizationRoute
  '/settings/storage': typeof ShellSettingsStorageRoute
  '/sources/$sourceId': typeof ShellSourcesSourceIdRouteWithChildren
  '/transforms/$transformId': typeof ShellTransformsTransformIdRoute
  '/destinations': typeof ShellDestinationsIndexRoute
  '/flows': typeof ShellFlowsIndexRoute
  '/issues': typeof ShellIssuesIndexRoute
  '/library': typeof ShellLibraryIndexRoute
  '/settings': typeof ShellSettingsIndexRoute
  '/sources': typeof ShellSourcesIndexRoute
  '/transforms': typeof ShellTransformsIndexRoute
  '/events/runs/$runId': typeof ShellEventsRunsRunIdRoute
  '/sources/$sourceId/clients/$customerId': typeof ShellSourcesSourceIdClientsCustomerIdRoute
  '/sources/$sourceId/clients': typeof ShellSourcesSourceIdClientsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteWithChildren
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/_shell/bookmarks': typeof ShellBookmarksRoute
  '/_shell/events': typeof ShellEventsRoute
  '/_shell/notifications': typeof ShellNotificationsRoute
  '/_shell/reference': typeof ShellReferenceRoute
  '/_shell/settings': typeof ShellSettingsRouteWithChildren
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/confirm-email': typeof AuthConfirmEmailRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_shell/destinations/$destinationId': typeof ShellDestinationsDestinationIdRoute
  '/_shell/dev/flow-kit': typeof ShellDevFlowKitRoute
  '/_shell/flows/$flowId': typeof ShellFlowsFlowIdRoute
  '/_shell/issues/$issueId': typeof ShellIssuesIssueIdRoute
  '/_shell/library/$itemId': typeof ShellLibraryItemIdRoute
  '/_shell/settings/account': typeof ShellSettingsAccountRoute
  '/_shell/settings/ai-usage': typeof ShellSettingsAiUsageRoute
  '/_shell/settings/credentials': typeof ShellSettingsCredentialsRoute
  '/_shell/settings/domains': typeof ShellSettingsDomainsRoute
  '/_shell/settings/keys': typeof ShellSettingsKeysRoute
  '/_shell/settings/members': typeof ShellSettingsMembersRoute
  '/_shell/settings/notifications': typeof ShellSettingsNotificationsRoute
  '/_shell/settings/organization': typeof ShellSettingsOrganizationRoute
  '/_shell/settings/storage': typeof ShellSettingsStorageRoute
  '/_shell/sources/$sourceId': typeof ShellSourcesSourceIdRouteWithChildren
  '/_shell/transforms/$transformId': typeof ShellTransformsTransformIdRoute
  '/_shell/destinations/': typeof ShellDestinationsIndexRoute
  '/_shell/flows/': typeof ShellFlowsIndexRoute
  '/_shell/issues/': typeof ShellIssuesIndexRoute
  '/_shell/library/': typeof ShellLibraryIndexRoute
  '/_shell/settings/': typeof ShellSettingsIndexRoute
  '/_shell/sources/': typeof ShellSourcesIndexRoute
  '/_shell/transforms/': typeof ShellTransformsIndexRoute
  '/_shell/events_/runs/$runId': typeof ShellEventsRunsRunIdRoute
  '/_shell/sources/$sourceId/clients/$customerId': typeof ShellSourcesSourceIdClientsCustomerIdRoute
  '/_shell/sources/$sourceId/clients/': typeof ShellSourcesSourceIdClientsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/register'
    | '/sign-in'
    | '/bookmarks'
    | '/events'
    | '/notifications'
    | '/reference'
    | '/settings'
    | '/auth/accept-invitation'
    | '/auth/confirm-email'
    | '/auth/reset-password'
    | '/destinations/$destinationId'
    | '/dev/flow-kit'
    | '/flows/$flowId'
    | '/issues/$issueId'
    | '/library/$itemId'
    | '/settings/account'
    | '/settings/ai-usage'
    | '/settings/credentials'
    | '/settings/domains'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/storage'
    | '/sources/$sourceId'
    | '/transforms/$transformId'
    | '/destinations/'
    | '/flows/'
    | '/issues/'
    | '/library/'
    | '/settings/'
    | '/sources/'
    | '/transforms/'
    | '/events/runs/$runId'
    | '/sources/$sourceId/clients/$customerId'
    | '/sources/$sourceId/clients/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/register'
    | '/sign-in'
    | '/bookmarks'
    | '/events'
    | '/notifications'
    | '/reference'
    | '/auth/accept-invitation'
    | '/auth/confirm-email'
    | '/auth/reset-password'
    | '/destinations/$destinationId'
    | '/dev/flow-kit'
    | '/flows/$flowId'
    | '/issues/$issueId'
    | '/library/$itemId'
    | '/settings/account'
    | '/settings/ai-usage'
    | '/settings/credentials'
    | '/settings/domains'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/storage'
    | '/sources/$sourceId'
    | '/transforms/$transformId'
    | '/destinations'
    | '/flows'
    | '/issues'
    | '/library'
    | '/settings'
    | '/sources'
    | '/transforms'
    | '/events/runs/$runId'
    | '/sources/$sourceId/clients/$customerId'
    | '/sources/$sourceId/clients'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/register'
    | '/sign-in'
    | '/_shell/bookmarks'
    | '/_shell/events'
    | '/_shell/notifications'
    | '/_shell/reference'
    | '/_shell/settings'
    | '/auth/accept-invitation'
    | '/auth/confirm-email'
    | '/auth/reset-password'
    | '/_shell/destinations/$destinationId'
    | '/_shell/dev/flow-kit'
    | '/_shell/flows/$flowId'
    | '/_shell/issues/$issueId'
    | '/_shell/library/$itemId'
    | '/_shell/settings/account'
    | '/_shell/settings/ai-usage'
    | '/_shell/settings/credentials'
    | '/_shell/settings/domains'
    | '/_shell/settings/keys'
    | '/_shell/settings/members'
    | '/_shell/settings/notifications'
    | '/_shell/settings/organization'
    | '/_shell/settings/storage'
    | '/_shell/sources/$sourceId'
    | '/_shell/transforms/$transformId'
    | '/_shell/destinations/'
    | '/_shell/flows/'
    | '/_shell/issues/'
    | '/_shell/library/'
    | '/_shell/settings/'
    | '/_shell/sources/'
    | '/_shell/transforms/'
    | '/_shell/events_/runs/$runId'
    | '/_shell/sources/$sourceId/clients/$customerId'
    | '/_shell/sources/$sourceId/clients/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRoute: typeof ShellRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  SignInRoute: typeof SignInRoute
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthConfirmEmailRoute: typeof AuthConfirmEmailRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/bookmarks': {
      id: '/_shell/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof ShellBookmarksRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/events': {
      id: '/_shell/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof ShellEventsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/notifications': {
      id: '/_shell/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof ShellNotificationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/reference': {
      id: '/_shell/reference'
      path: '/reference'
      fullPath: '/reference'
      preLoaderRoute: typeof ShellReferenceRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/settings': {
      id: '/_shell/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ShellSettingsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/auth/accept-invitation': {
      id: '/auth/accept-invitation'
      path: '/auth/accept-invitation'
      fullPath: '/auth/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/confirm-email': {
      id: '/auth/confirm-email'
      path: '/auth/confirm-email'
      fullPath: '/auth/confirm-email'
      preLoaderRoute: typeof AuthConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/destinations/': {
      id: '/_shell/destinations/'
      path: '/destinations'
      fullPath: '/destinations/'
      preLoaderRoute: typeof ShellDestinationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/destinations/$destinationId': {
      id: '/_shell/destinations/$destinationId'
      path: '/destinations/$destinationId'
      fullPath: '/destinations/$destinationId'
      preLoaderRoute: typeof ShellDestinationsDestinationIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dev/flow-kit': {
      id: '/_shell/dev/flow-kit'
      path: '/dev/flow-kit'
      fullPath: '/dev/flow-kit'
      preLoaderRoute: typeof ShellDevFlowKitRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/flows/': {
      id: '/_shell/flows/'
      path: '/flows'
      fullPath: '/flows/'
      preLoaderRoute: typeof ShellFlowsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/flows/$flowId': {
      id: '/_shell/flows/$flowId'
      path: '/flows/$flowId'
      fullPath: '/flows/$flowId'
      preLoaderRoute: typeof ShellFlowsFlowIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/issues/': {
      id: '/_shell/issues/'
      path: '/issues'
      fullPath: '/issues/'
      preLoaderRoute: typeof ShellIssuesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/issues/$issueId': {
      id: '/_shell/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/issues/$issueId'
      preLoaderRoute: typeof ShellIssuesIssueIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/library/': {
      id: '/_shell/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof ShellLibraryIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/library/$itemId': {
      id: '/_shell/library/$itemId'
      path: '/library/$itemId'
      fullPath: '/library/$itemId'
      preLoaderRoute: typeof ShellLibraryItemIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/settings/': {
      id: '/_shell/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof ShellSettingsIndexRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/account': {
      id: '/_shell/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof ShellSettingsAccountRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/ai-usage': {
      id: '/_shell/settings/ai-usage'
      path: '/ai-usage'
      fullPath: '/settings/ai-usage'
      preLoaderRoute: typeof ShellSettingsAiUsageRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/credentials': {
      id: '/_shell/settings/credentials'
      path: '/credentials'
      fullPath: '/settings/credentials'
      preLoaderRoute: typeof ShellSettingsCredentialsRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/domains': {
      id: '/_shell/settings/domains'
      path: '/domains'
      fullPath: '/settings/domains'
      preLoaderRoute: typeof ShellSettingsDomainsRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/keys': {
      id: '/_shell/settings/keys'
      path: '/keys'
      fullPath: '/settings/keys'
      preLoaderRoute: typeof ShellSettingsKeysRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/members': {
      id: '/_shell/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof ShellSettingsMembersRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/notifications': {
      id: '/_shell/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof ShellSettingsNotificationsRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/organization': {
      id: '/_shell/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof ShellSettingsOrganizationRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/settings/storage': {
      id: '/_shell/settings/storage'
      path: '/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof ShellSettingsStorageRouteImport
      parentRoute: typeof ShellSettingsRoute
    }
    '/_shell/sources/': {
      id: '/_shell/sources/'
      path: '/sources'
      fullPath: '/sources/'
      preLoaderRoute: typeof ShellSourcesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/sources/$sourceId': {
      id: '/_shell/sources/$sourceId'
      path: '/sources/$sourceId'
      fullPath: '/sources/$sourceId'
      preLoaderRoute: typeof ShellSourcesSourceIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transforms/': {
      id: '/_shell/transforms/'
      path: '/transforms'
      fullPath: '/transforms/'
      preLoaderRoute: typeof ShellTransformsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transforms/$transformId': {
      id: '/_shell/transforms/$transformId'
      path: '/transforms/$transformId'
      fullPath: '/transforms/$transformId'
      preLoaderRoute: typeof ShellTransformsTransformIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/events_/runs/$runId': {
      id: '/_shell/events_/runs/$runId'
      path: '/events/runs/$runId'
      fullPath: '/events/runs/$runId'
      preLoaderRoute: typeof ShellEventsRunsRunIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/sources/$sourceId/clients/': {
      id: '/_shell/sources/$sourceId/clients/'
      path: '/clients'
      fullPath: '/sources/$sourceId/clients/'
      preLoaderRoute: typeof ShellSourcesSourceIdClientsIndexRouteImport
      parentRoute: typeof ShellSourcesSourceIdRoute
    }
    '/_shell/sources/$sourceId/clients/$customerId': {
      id: '/_shell/sources/$sourceId/clients/$customerId'
      path: '/clients/$customerId'
      fullPath: '/sources/$sourceId/clients/$customerId'
      preLoaderRoute: typeof ShellSourcesSourceIdClientsCustomerIdRouteImport
      parentRoute: typeof ShellSourcesSourceIdRoute
    }
  }
}

interface ShellSettingsRouteChildren {
  ShellSettingsAccountRoute: typeof ShellSettingsAccountRoute
  ShellSettingsAiUsageRoute: typeof ShellSettingsAiUsageRoute
  ShellSettingsCredentialsRoute: typeof ShellSettingsCredentialsRoute
  ShellSettingsDomainsRoute: typeof ShellSettingsDomainsRoute
  ShellSettingsKeysRoute: typeof ShellSettingsKeysRoute
  ShellSettingsMembersRoute: typeof ShellSettingsMembersRoute
  ShellSettingsNotificationsRoute: typeof ShellSettingsNotificationsRoute
  ShellSettingsOrganizationRoute: typeof ShellSettingsOrganizationRoute
  ShellSettingsStorageRoute: typeof ShellSettingsStorageRoute
  ShellSettingsIndexRoute: typeof ShellSettingsIndexRoute
}

const ShellSettingsRouteChildren: ShellSettingsRouteChildren = {
  ShellSettingsAccountRoute: ShellSettingsAccountRoute,
  ShellSettingsAiUsageRoute: ShellSettingsAiUsageRoute,
  ShellSettingsCredentialsRoute: ShellSettingsCredentialsRoute,
  ShellSettingsDomainsRoute: ShellSettingsDomainsRoute,
  ShellSettingsKeysRoute: ShellSettingsKeysRoute,
  ShellSettingsMembersRoute: ShellSettingsMembersRoute,
  ShellSettingsNotificationsRoute: ShellSettingsNotificationsRoute,
  ShellSettingsOrganizationRoute: ShellSettingsOrganizationRoute,
  ShellSettingsStorageRoute: ShellSettingsStorageRoute,
  ShellSettingsIndexRoute: ShellSettingsIndexRoute,
}

const ShellSettingsRouteWithChildren = ShellSettingsRoute._addFileChildren(
  ShellSettingsRouteChildren,
)

interface ShellSourcesSourceIdRouteChildren {
  ShellSourcesSourceIdClientsCustomerIdRoute: typeof ShellSourcesSourceIdClientsCustomerIdRoute
  ShellSourcesSourceIdClientsIndexRoute: typeof ShellSourcesSourceIdClientsIndexRoute
}

const ShellSourcesSourceIdRouteChildren: ShellSourcesSourceIdRouteChildren = {
  ShellSourcesSourceIdClientsCustomerIdRoute:
    ShellSourcesSourceIdClientsCustomerIdRoute,
  ShellSourcesSourceIdClientsIndexRoute: ShellSourcesSourceIdClientsIndexRoute,
}

const ShellSourcesSourceIdRouteWithChildren =
  ShellSourcesSourceIdRoute._addFileChildren(ShellSourcesSourceIdRouteChildren)

interface ShellRouteChildren {
  ShellBookmarksRoute: typeof ShellBookmarksRoute
  ShellEventsRoute: typeof ShellEventsRoute
  ShellNotificationsRoute: typeof ShellNotificationsRoute
  ShellReferenceRoute: typeof ShellReferenceRoute
  ShellSettingsRoute: typeof ShellSettingsRouteWithChildren
  ShellDestinationsDestinationIdRoute: typeof ShellDestinationsDestinationIdRoute
  ShellDevFlowKitRoute: typeof ShellDevFlowKitRoute
  ShellFlowsFlowIdRoute: typeof ShellFlowsFlowIdRoute
  ShellIssuesIssueIdRoute: typeof ShellIssuesIssueIdRoute
  ShellLibraryItemIdRoute: typeof ShellLibraryItemIdRoute
  ShellSourcesSourceIdRoute: typeof ShellSourcesSourceIdRouteWithChildren
  ShellTransformsTransformIdRoute: typeof ShellTransformsTransformIdRoute
  ShellDestinationsIndexRoute: typeof ShellDestinationsIndexRoute
  ShellFlowsIndexRoute: typeof ShellFlowsIndexRoute
  ShellIssuesIndexRoute: typeof ShellIssuesIndexRoute
  ShellLibraryIndexRoute: typeof ShellLibraryIndexRoute
  ShellSourcesIndexRoute: typeof ShellSourcesIndexRoute
  ShellTransformsIndexRoute: typeof ShellTransformsIndexRoute
  ShellEventsRunsRunIdRoute: typeof ShellEventsRunsRunIdRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellBookmarksRoute: ShellBookmarksRoute,
  ShellEventsRoute: ShellEventsRoute,
  ShellNotificationsRoute: ShellNotificationsRoute,
  ShellReferenceRoute: ShellReferenceRoute,
  ShellSettingsRoute: ShellSettingsRouteWithChildren,
  ShellDestinationsDestinationIdRoute: ShellDestinationsDestinationIdRoute,
  ShellDevFlowKitRoute: ShellDevFlowKitRoute,
  ShellFlowsFlowIdRoute: ShellFlowsFlowIdRoute,
  ShellIssuesIssueIdRoute: ShellIssuesIssueIdRoute,
  ShellLibraryItemIdRoute: ShellLibraryItemIdRoute,
  ShellSourcesSourceIdRoute: ShellSourcesSourceIdRouteWithChildren,
  ShellTransformsTransformIdRoute: ShellTransformsTransformIdRoute,
  ShellDestinationsIndexRoute: ShellDestinationsIndexRoute,
  ShellFlowsIndexRoute: ShellFlowsIndexRoute,
  ShellIssuesIndexRoute: ShellIssuesIndexRoute,
  ShellLibraryIndexRoute: ShellLibraryIndexRoute,
  ShellSourcesIndexRoute: ShellSourcesIndexRoute,
  ShellTransformsIndexRoute: ShellTransformsIndexRoute,
  ShellEventsRunsRunIdRoute: ShellEventsRunsRunIdRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRoute: ShellRouteWithChildren,
  RegisterRoute: RegisterRoute,
  SignInRoute: SignInRoute,
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthConfirmEmailRoute: AuthConfirmEmailRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
